<template>
    <div :id="id" :style="chartStyle"></div>
</template>

<script>
/**
 * ECharts 折线图组件
 * @description 用于展示折线图数据
 */
import * as echarts from 'echarts';

export default {
    name: 'EchartLine',
    
    data() {
        return {
            chart: null // ECharts 实例
        };
    },
    
    props: {
        // 图表 ID
        id: {
            type: String,
            default: 'line'
        },
        // 图表宽度
        width: {
            type: String,
            default: '100%'
        },
        // 图表高度
        height: {
            type: [String, Number],
            default: 400
        },
        // X 轴数据
        xAxis: {
            type: Array,
            default: () => ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        },
        // 图表系列数据
        series: {
            type: Array,
            default: () => [{
                type: 'line',
                data: [150, 230, 224, 218, 135, 147, 260]
            }]
        },
        // 图表标题
        title: {
            type: String,
            default: '数据统计'
        },
        // 图例配置
        legend: {
            type: Object,
            default: () => ({})
        },
        // 标题位置
        titleCenter: {
            type: String,
            default: 'center'
        }
    },
    
    computed: {
        /**
         * 计算图表样式
         */
        chartStyle() {
            const height = typeof this.height === 'number' ? `${this.height}px` : this.height;
            return {
                height: height,
                width: this.width
            };
        }
    },
    
    mounted() {
        this.initChart();
    },
    
    beforeDestroy() {
        // 组件销毁前，清理 ECharts 实例，防止内存泄漏
        this.disposeChart();
    },
    
    methods: {
        /**
         * 初始化图表
         */
        initChart() {
            // 获取 DOM 元素
            const chartDom = document.getElementById(this.id);
            
            // 检查 DOM 是否存在
            if (!chartDom) {
                console.error(`❌ Chart DOM element with id "${this.id}" not found`);
                return;
            }
            
            // 初始化 ECharts 实例
            this.chart = echarts.init(chartDom);
            
            // 配置图表选项
            const option = {
                title: {
                    text: this.title,
                    left: this.titleCenter,
                    textStyle: {
                        fontSize: 16,
                        fontWeight: 'normal'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(50, 50, 50, 0.8)',
                    textStyle: {
                        color: '#fff'
                    }
                },
                legend: this.legend,
                xAxis: {
                    type: 'category',
                    data: this.xAxis,
                    boundaryGap: false
                },
                yAxis: {
                    type: 'value'
                },
                series: this.series,
                grid: {
                    x: 50,
                    y: 50,
                    x2: 30,
                    y2: 50,
                    containLabel: true
                },
                // 动画配置
                animation: true,
                animationDuration: 1000,
                animationEasing: 'cubicOut'
            };
            
            // 设置图表配置
            this.chart.setOption(option);
            
            // 监听窗口变化，自动调整图表大小
            this.handleResize();
        },
        
        /**
         * 处理窗口大小变化
         */
        handleResize() {
            if (this.chart) {
                this.chart.resize();
            }
        },
        
        /**
         * 销毁图表实例
         */
        disposeChart() {
            if (this.chart) {
                this.chart.dispose();
                this.chart = null;
            }
        }
    }
};
</script>
